import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ScreenSize, WindowService } from '../../_service/screen-size.service';
import { NavbarLinksService } from '../../_service/navbar/navbar.service';
import { NavigationEnd, Router } from '@angular/router';
import { CategoryService } from '../../_service/category/category.service';
import { RechargeBoxService } from '../../_service/recharge-box/recharge-box.service';
import { environment } from '../../../environments/environment';
import { Unsubscribable } from 'rxjs';
import { Utility } from '../../_service/utility';
import { SettingsService } from 'app/user-center/settings/settings.service';
import { UserService } from 'app/_service/user/user.service';

@Component({
  selector: 'app-nav-panel',
  templateUrl: './nav-panel.component.html',
  styleUrls: ['./nav-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NavPanelComponent implements OnInit,OnChanges, OnDestroy {
  ngOnDestroy(): void {

    this.subscriptions.forEach(p => p.unsubscribe())

  }
  @Input() CID = "0,1";
  screenType = ScreenSize;
  allVip = false;
  screenSize;
  firstclassLinks = [];
  baseUrl;
  componentClass;
  isAdult = environment.cinema === 2;
  adultFav;
  shouldHideAdult = environment.cinema == 1 && this._utility.getSiteConfig.hidecinema == 2;
  recommends = [];
  enableDownload = this._utility.getSiteConfig.enableAndroidDownload || this._utility.getSiteConfig.enableIOSDonwload;
  links = [
    {
      label: '直播',
      link: 'https://miolive.tv',
      external: true
    },
    {
      label: '页游',
      link: 'http://www.dngame.eu/',
      external: true
    },
    {
      label: '手游',
      link: 'http://yoyou.dngame.eu/GotoPlayfromAD/gtp-wzcq-m.html',
      external: true
    },
    {
      label: '视频',
      link: 'https://www.ifvod.tv/',
      external: true,
      home: environment.cinema == 1
    }
  ];

  emptyLinks = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  subscriptions: Array<Unsubscribable> = [];
  isNSFWMode = true;
  user;
  private lastToken = '';
  newMainMenu;
  externalList = [];
  constructor(
    private _navbarService: NavbarLinksService,
    // private _categoryService: CategoryService,
    private _rechargeBoxService: RechargeBoxService,
    private _utility: Utility,
    // private _router: Router,
     private _cd: ChangeDetectorRef,
     private settingsService: SettingsService,
     private _userService: UserService,
     private _windowService: WindowService,
  ) {
    this.isNSFWMode = this.getWySetting() == '1' ? true : false;
  }

  readState() {
    if (!!this.user.id
      && this.lastToken != this.user.token.token) {
      this.lastToken = this.user.token.token; // on user login
    } else if (!!this.lastToken
      && this.lastToken != this.user?.token?.token) {
      this.lastToken = '';
      this.onUserLogout();
    }
  }

  private getWySetting():any{
    if (localStorage.getItem('showWY')) {
      return JSON.parse(localStorage.getItem('showWY'));
    }
    return '1';
  }

  onUserLogout() {
    this.isNSFWMode = this.getWySetting() == '1' ? true : false;
    this._cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["CID"] && !!changes["CID"].currentValue)
    {
      this.loadingMenu = true;
      if (this.CID !== '0,1') {
        this._navbarService.getNavbarLinks(this.CID);
        this._navbarService.getNavbarSecondLinks(this.CID, 20);
      } else {
        this._navbarService.getNewNavbarLinks(this.CID);
      }
      this.componentClass = this.CID == "0,1,5" ?"variety":this.CID =="0,1,7"?"documentary":"";
    }
  }

  hideAds = this._utility.getSiteConfig.hideAds;
  //width = 500;
  app = environment.app;
  loadingMenu = false;
  ngOnInit() {
    // let cid = this.getCID();
    // this._navbarService.getNavbarLinks(cid);
    // this._navbarService.getNavbarSecondLinks(cid, 20)

    this.subscriptions.push(
      // this._router.events.subscribe((evt) => {
      //   if (evt instanceof NavigationEnd) {
      //     this.loadingMenu = true;
      //     let cid = this.getCID();
      //     this._navbarService.getNavbarLinks(cid);
      //     this._navbarService.getNavbarSecondLinks(cid, 20)
      //   }
      // }),

      this._windowService.size$.subscribe((value: any) => {
        this.screenSize = value;
        if (!!this.newMainMenu) {
          this.fillUpLinks(this.newMainMenu);
        }
      }),
      this._navbarService.newMainMenuSource$.subscribe(source => {
        // 主页，新整合菜单导航
        if (this.CID === '0,1') {
          this.loadingMenu = false;
          if (source && !!source[this.CID]) {
            const res = source[this.CID];
            this.newMainMenu = !!res.items[0] ? res.items[0] : undefined;
            if (!!this.newMainMenu) {
              this.fillUpLinks(this.newMainMenu);
            };
          }
        }
      }),

      this._navbarService.linksSource$.subscribe(source => {
        this.loadingMenu = false;
        if (source && !!source[this.CID]) {
          const res = source[this.CID];
          //this.firstclassLinks = res.items;
          for(let i =0;i<res.items.length;++i)
          {
            if(this.firstclassLinks.length>i)
            this.firstclassLinks[i]= res.items[i];
            else
            {
              this.firstclassLinks.push(res.items[i]);
            }
          }
          this._cd.detectChanges();
        }

      }),

      this._navbarService.secondLinksSource$.subscribe(res => {
        let key = `sec${this.CID}_20`;
        if (res && res[key]) {
          this.recommends = res[key].result;
          this._cd.detectChanges();
        }

      }),

      this.settingsService.settings$.subscribe(settings => {
        if ('isNSFWMode' in settings) {
          this.isNSFWMode = settings.isNSFWMode;
          localStorage.setItem('showWY', this.isNSFWMode ? '1' : '0');
          this._cd.detectChanges();
        }
      }),

      this._userService.userState$.subscribe(user => {
        this.user = user;
        this.readState();
      }),
    )

  }

  // private getCID() {
  //   this.baseUrl = this._utility.getUrlPath(this._router.url.split('?')).split('/')[0];
  //   if (this.baseUrl) {
  //     this.componentClass = this.baseUrl;
  //   } else {
  //     this.componentClass = 'homepage-nav';
  //   }
  //   let cid;
  //   const category = this._categoryService.getCategoryBySlug(this.baseUrl);
  //   if (category) {
  //     cid = category.cid;
  //   } else {
  //     cid = '0,1';
  //   }

  //   return cid;
  // }



  showRechargeBox() {
    this._rechargeBoxService.changeDisplayStatus(true);
  }

  moreItem = {
    category: "more",
    external: false,
    image: null,
    isNew: false,
    label: "更多",
    link: "list",
    notifications: 0,
    params: null,
    path: "list",
  };

  fillUpLinks(mainMenu) {
    // console.log(mainMenu);
    // console.log(this.screenSize);
    if (!!mainMenu) {
      const insertIndex = this.screenSize > 2 ? 6 : 5;
      const insertIndex2 = (insertIndex * 2) + 1;
      let newList = [...mainMenu['channelList']];
      newList.splice(insertIndex, 0, ...mainMenu['attachList']);
      newList.splice(insertIndex2, 0, this.moreItem);
      this.firstclassLinks = newList;
      this.recommends = mainMenu['recommList'].map(item => {
        return {
          ...item,
          title: item.label,
          updateNumber: item.notifications,
        }
      });
      this.externalList = mainMenu['externalList'];
      this._cd.detectChanges();
    }
  }

}
